import React from 'react';
import { useTheme } from '../../styles/ThemeProvider';

export const ThemeToggle = ({ expanded = true }) => {
  const { mode, setMode } = useTheme();
  return (
    <button
      onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
      title={mode === 'dark' ? 'Aydınlık tema' : 'Karanlık tema'}
      style={{
        width: '100%',
        padding: '15px 20px',
        background: 'transparent',
        border: 'none',
        color: 'rgba(255,255,255,0.7)',
        textAlign: expanded ? 'left' : 'center',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontSize: '14px',
      }}
      onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
      onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}>
      <span style={{ fontSize: '18px' }}>{mode === 'dark' ? '☀️' : '🌙'}</span>
      {expanded && <span>{mode === 'dark' ? 'Aydınlık Tema' : 'Karanlık Tema'}</span>}
    </button>
  );
};
